import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as Traits from 'actions/Traits';

export function* onGetCharacteristicGiversRequest({ params, cb }) {
	try {
		const { size=20, page=0, studentId=null, userType=null } = params;
		const rs = yield axios.get(`/api/student/${studentId}/getCharacteristicGivers?size=${size}&page=${page}`);
		//console.log('response', rs.data)
		yield put(Traits.onGetCharacteristicGiversSuccess({data: rs.data, studentId: studentId, userType: userType}));
		cb && cb(null, rs.data);
	} catch (e) {
		console.log('Error: onGetCharacteristicGiversRequest', e.toString());
		yield put(Traits.onGetCharacteristicGiversSuccess());
		cb && cb(e);
	}
}